<template>
  <img id="logo-square-lightable"/>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables.scss";

  #logo-square-lightable {
    content: url(~BRAND/assets/login-logo-mobile.svg);
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/logos/LoginLogoMobile.vue